import Vue from "vue";
import Component from "vue-class-component";
import DateObject from "@/shared/dateObject";
import moment from "moment/moment";

@Component
export default class MyMixin extends Vue {
  public checkPeriode(typePeriode: number, periode: string): any {
    let dateObj: DateObject;
    let maDate;
    let i: number = 0;
    switch (periode) {
      case "J_PRECEDENT":
      case "MOIS_PRECEDENT":
      case "SEMAINE_PRECEDENTE":
      case "ANNEE_PRECEDENTE":
        i = 1;
        break;
      case "AVANT_HIER":
      case "MOISMOINSDEUX":
      case "SEMAINE_MOINS_DEUX":
        i = 2;
        break;
      case "J-3":
        i = 3;
        break;
    }
    // console.log(typePeriode, periode);
    switch (typePeriode) {
      case 0:
        maDate = moment().subtract(i, "d").toDate();
        dateObj = this.formatDateDay(maDate);
        break;
      case 1:
        maDate = moment().subtract(i, "w").startOf("isoWeek");
        dateObj = this.formatDateWeek(maDate.toDate());
        break;
      case 2:
        if (periode === "SIX_DERNIERS_MOIS") {
          dateObj = this.formatDateSixMonth();
        } else {
          maDate = moment().subtract(i, "month").startOf("month");
          dateObj = this.formatDateMonth(maDate.toDate());
        }
        break;
      case 3:
        maDate = moment().subtract(i, "y").startOf("year");
        dateObj = this.formatDateYear(maDate.toDate());
        break;
      default: {
        maDate = moment().subtract(i, "d").toDate();
        dateObj = this.formatDateDay(maDate);
        break;
      }
    }
    // console.log(dateObj.start, dateObj.end);
    return dateObj;
  }

  public formatDateSixMonth(): DateObject {
    const maDate = moment().subtract(5, "month").startOf("month").toDate();
    const endDate = moment().endOf("month").toDate();
    const dateObj: DateObject = {
      timestamp: maDate,
      jour: moment(maDate).format("MM"),
      lib: moment(maDate).format("MMMM"),
      end: endDate,
      start: maDate,
    };
    return dateObj;
  }

  public formatDateDay(maDate: Date): DateObject {
    const dateObj = {
      timestamp: maDate,
      jour: moment(maDate).format("DD"),
      lib: moment(maDate).format("dddd"),
      start: maDate,
      end: maDate,
    };
    // console.log(dateObj);
    return dateObj;
  }
  /**
   * mise en forme de la date pour format semaine
   * @param maDate : string la date à formater
   */
  public formatDateWeek(maDate: Date): DateObject {
    const endDate = moment(maDate).add(6, "d").toDate();
    const dateObj = {
      timestamp: maDate,
      lib:
        moment(maDate).format("DD/MM") + "-" + moment(endDate).format("DD/MM"),
      jour: this.$t("LUN_A_DIM") + " " + moment(maDate).format("ww"),
      end: endDate,
      start: maDate,
    };
    return dateObj;
  }

  /**
   * mise en forme de la date pour format décade
   * @param maDate : string la date à formater
   */
  public formatDateDecade(maDate: Date): DateObject {
    let endDate = new Date();
    const decadeNum = this.getDecadeNumber(maDate);
    switch (decadeNum) {
      case 1:
        maDate = moment(maDate).startOf("months").toDate();
        endDate = moment(maDate).add(9, "d").toDate();
        break;
      case 2:
        maDate = moment(maDate).date(11).toDate();
        endDate = moment(maDate).add(9, "d").toDate();
        break;
      case 3:
        maDate = moment(maDate).date(21).toDate();
        endDate = moment(maDate).endOf("month").toDate();
        break;
    }
    // const endDate = moment(maDate).add(10, "d").toDate();
    const dateObj = {
      timestamp: maDate,
      lib:
        moment(maDate).format("DD/MM") + "-" + moment(endDate).format("DD/MM"),
      jour: "D" + decadeNum + " " + moment(maDate).format("MM"),
      end: endDate,
      start: maDate,
    };
    return dateObj;
  }

  public getMaDateDecade(maDate: Date, i: number): Date {
    // console.log("je veux la décade -", i, i * 10, maDate);
    const decade = this.formatDateDecade(maDate);
    const newDate = moment(decade.start)
      .subtract(i * 10, "d")
      .toDate();
    const decadeNum = this.getDecadeNumber(newDate);
    switch (decadeNum) {
      case 1:
        maDate = moment(newDate).startOf("months").toDate();
        break;
      case 2:
        maDate = moment(newDate).date(11).toDate();
        break;
      case 3:
        maDate = moment(newDate).date(21).toDate();
        break;
      default:
        maDate = moment(newDate).startOf("months").toDate();
        break;
    }
    return maDate;
  }

  public getDecadeNumber(date: Date) {
    const day: number = moment(date).date();
    // console.log(day);
    if (day <= 10) {
      return 1;
    } else if (10 < day && day <= 20) {
      return 2;
    } else {
      return 3;
    }
  }

  public calculateDate(
    date: Date,
    change: "week" | "year" | "month" | "day",
    quantity: number
  ) {
    return moment(date).subtract(quantity, change);
  }

  /**
   * mise en forme de la date pour format semaine
   * @param maDate : string la date à formater
   */
  public makeMeAWeek(maDate: Date): DateObject {
    maDate = moment(maDate).startOf("week").toDate();
    const endDate = moment(maDate).add(6, "d").toDate();
    const dateObj = {
      timestamp: maDate,
      lib:
        moment(maDate).format("DD/MM/YY") +
        " - " +
        moment(endDate).format("DD/MM/YY"),
      jour: "s " + moment(maDate).format("ww"),
      end: endDate,
      start: maDate,
    };
    return dateObj;
  }

  public formatDateMonth(maDate: Date): DateObject {
    // console.log(maDate);
    const dateObj = {
      timestamp: moment(maDate).toDate(),
      jour: moment(maDate).format("MM"),
      lib: moment(maDate).format("MMMM"),
      end: moment(maDate).endOf("month").toDate(),
      start: moment(maDate).toDate(),
    };
    return dateObj;
  }
  /**
   * @vuese
   * methode de transformation d'une date en DateObject année
   * @param maDate : la date à transformer
   * @returns la date au type DateObject (pour date chooser)
   */
  public formatDateYear(maDate: Date): DateObject {
    const dateObj = {
      timestamp: maDate,
      lib: "",
      jour: moment(maDate).format("YYYY"),
      end: moment(maDate).endOf("year").toDate(),
      start: maDate,
    };
    return dateObj;
  }

  public getSameDayLastYear(date: Date) {
    const day = moment(date).day();
    const lastYear = moment(date).subtract(1, "y").day(day);
    return lastYear;
  }

  public getSameDayLastMonth(date: Date) {
    const day = moment(date).day();
    const lastYear = moment(date).subtract(1, "month").day(day);
    return lastYear;
  }

  public getSameWeekLastYear(date: Date) {
    const w = moment(date).week();
    const lastYear = moment(date).subtract(1, "y").week(w);
    return lastYear;
  }

  /*****  formatage des dates pour affichage ******/

  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public formatDate(date: Date) {
    const d = moment(date).format("DD/MM/YYYY");
    return d;
  }
  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public formatDateFull(date: Date) {
    const d = moment(date).format("dddd DD MMMM YYYY");
    return d;
  }
  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public formatDateTimestamp(date: number) {
    const d = moment(date).format("DD/MM/YYYY");
    return d;
  }
  /**
   * methode d'affichage du mois et de l'année
   */
  public formatDateMonthYear(date: Date) {
    const d = moment(date).format("MMMM YYYY");
    return d;
  }
  /**
   *  methode de formatage de la date pour affichage
   * @param horodatage : l'horodatage à transformer
   * @returns la date dans le bon format sous forme de string
   */
  public formatDateTicket(horodatage: number) {
    const d = moment(horodatage).format("DD/MM/YYYY");
    return d;
  }
  /**
   *  methode de formatage de la date avec heure
   * @param horodatage : l'horodatage à transformer
   * @returns la date dans le bon format sous forme de string
   */
  public formatDateTicketHour(horodatage: number) {
    const d = moment(horodatage).format("DD/MM/YYYY HH:mm");
    return d;
  }
  /**
   *  methode de formatage de la date pour envoie de l'heure
   * @param horodatage: la date à formater
   * @returns la date dans le bon format sous forme de string
   */
  public formatTicketHour(horodatage: number) {
    const d = moment(horodatage).format("HH:mm");
    return d;
  }
  /**
   *  methode de formatage de la date pour envoie au serveur
   * @param date: la date à formater
   * @returns la date dans le bon format sous forme de string
   */
  public formatDateSend(date: Date) {
    const d = moment(date).format("YYYY-MM-DD");
    return d;
  }
  /**
   *
   * @param date parsage de la date pour envoie au datepicker
   */
  public getDateToPick(date: any) {
    const mydate = new Date(date).toISOString().substr(0, 10);
    return mydate;
  }

  public getAllDaysPeriode(dateDebut: Date, dateFin: Date) {
    const dates = new Array();
    dates.push(moment(dateDebut).format("YYYY-MM-DD"));
    const debut = moment(dateDebut);
    const end = moment(dateFin);

    const diff = end.diff(debut, "d") - 2;
    if (diff < 0) {
      return dates;
    }
    for (let i = 0; i <= diff; i++) {
      debut.add(1, "d");
      dates.push(debut.format("YYYY-MM-DD"));
    }
    dates.push(moment(end).format("YYYY-MM-DD"));
    // console.log(dates);
    return dates;
  }
}
